<template>
<!-- 拟建项目 -->
    <div class="contain desPro">
         <el-tabs v-model="activeName" type="card"  style="height:100%;background:#fff" @tab-click=handleClick>
           <el-tab-pane    v-for="item in list" :key="item.value"  :label="item.label"  :value="item.value"  :name="item.name">
             <div class="box">
               <div class="build-bar">
                 <div style="margin-right:20px">
                   <el-input v-if="item.value==1"  placeholder="接收人搜索" v-model="search.receiveBy " style="width:12vw;"></el-input>
                   <el-input v-else  placeholder="移交人搜索" v-model="search.createBy " style="width:12vw;"></el-input>
                </div>   
                <div style="margin-right:20px">
                   <el-input placeholder="请输入合同名称" v-model="search.contractName " style="width:12vw;"></el-input>
                 </div> 
                <div style="width:300px;margin-right:20px">
                   <el-button type="primary" class="add-user" @click="doFilter" >查询</el-button>
                </div>  
                <div style="width:300px;margin-right:20px">
                   <el-button type="primary" class="add-user" @click="add" >添加移交</el-button>
                </div>  
               </div>
               <div class="box-content">
                   <el-table
                       :data="listData"
                       border
                       stripe
                       height="100%"
                       style="width: 100%;"
                   >
                       <template slot="empty">
                           <p>{{dataText}}</p>
                       </template>
                       <el-table-column label="序号" width="60">
                           <template slot-scope="scope">
                               <span>{{ scope.row.index }}</span>
                           </template>
                       </el-table-column>
                       <el-table-column label="合同编号">
                         <template slot-scope="scope">
                               <span>{{ scope.row.contractInitId }}</span>
                          </template>
                       </el-table-column>
                       <el-table-column label="合同名称">
                           <template slot-scope="scope">
                               <span>{{ scope.row.contractName }}</span>
                           </template>
                       </el-table-column>

                       <el-table-column label="合同负责人">
                           <template slot-scope="scope">
                             <span>{{ scope.row.principal }}</span>
                           </template>
                       </el-table-column>
                       <el-table-column label="合同创建者">
                           <template slot-scope="scope">
                               <span>{{ scope.row.createBy }}</span>
                           </template>
                       </el-table-column>
                       <el-table-column label="移交时间">
                           <template slot-scope="scope">
                               <span>{{ scope.row.createDate }}</span>
                           </template>
                       </el-table-column>
                       <el-table-column label="移交人">
                           <template slot-scope="scope">
                               <span>{{ scope.row.receiveBy }}</span>
                           </template>
                       </el-table-column>
                        <el-table-column label="接收时间">
                           <template slot-scope="scope">
                               <span>{{ scope.row.receiveDate }}</span>
                           </template>
                         </el-table-column>
                     <el-table-column label="接收人">
                           <template slot-scope="scope">
                               <span>{{ scope.row.receiveBy }}</span>
                           </template>
                         </el-table-column>
                     <el-table-column label="状态">
                        <template slot-scope="scope">
                            <span v-if="scope.row.yesNo=='0'">未开始</span>
                            <span v-else-if="scope.row.yesNo=='1'">已接收</span>
                            <span v-else-if="scope.row.yesNo=='2'">未接收</span>
                        </template>
                    </el-table-column>
                   <el-table-column label="备注">
                        <template slot-scope="scope">
                            <span>{{ scope.row.note}}</span>
                        </template>
                    </el-table-column>
                     <el-table-column label="附件">
                        <template slot-scope="scope">
                            <el-button v-if="scope.row.file && scope.row.file!=''" type="text" @click="toFile(scope.row.file)">查看</el-button>
                            <el-button v-else type="text" disabled>查看</el-button>
                            <!-- <span>{{ scope.row.file}}</span> -->
                        </template>
                    </el-table-column>
                       <el-table-column label="操作">
                           <template slot-scope="scope">
                               <el-button type="text" @click="handleEdit(scope.$index, scope.row)">移交记录</el-button>
                           </template>
                       </el-table-column>
                   </el-table>
                   <!-- 表单列表 -->
                   <el-pagination
                   @size-change="handleSizeChange"
                   @current-change="handleCurrentChange"
                   :current-page="currentPage"
                   :page-sizes="[3, 5, 10, 20]"
                   :page-size="pageSize"
                   layout="total, sizes, prev, pager, next, jumper"
                   :total="totalItems"
                   style="padding-top:10px;"
                   ></el-pagination>
             
               </div>
             </div>

           </el-tab-pane>
          
         </el-tabs>
        <!-- 详情弹出框 -->           
          <el-dialog
                 title="移交记录"
                 :visible.sync="dialogTableVisible"
                 style="border-bottom:1px solid #000;color:#000;"
               >
                <div>
                    <div style="display:flex;align-items:center;justify-content: space-between;padding: 10px;font-weight:bolder">
                    合同名称：{{addForm.contractName}}
                    </div>
                    <div style="display:flex;align-items:center;justify-content: space-between;padding: 10px;font-weight:bolder">
                    接收人：{{addForm.receiveBy}}
                    </div>
                    <div style="display:flex;align-items:center;justify-content: space-between;padding: 10px;font-weight:bolder">
                    移交附件：{{addForm.file}}
                    </div>
                    <div style="display:flex;align-items:center;justify-content: space-between;padding: 10px;font-weight:bolder">
                    备注：{{addForm.note}}
                    </div>
                </div>
                 <div style="display:flex;justify-content: space-between;padding: 10px;font-weight:bolder">
                      移交记录:
                 <el-table :data="gridData" >
                   <el-table-column type="index" label="序号" width="100"></el-table-column>
                    <el-table-column property="handOver" label="移交人"></el-table-column>
                    <el-table-column property="createDate" label="移交时间"></el-table-column>
                    <el-table-column property="receiveBy" label="接收人"></el-table-column>
                    <el-table-column property="receiveDate" label="接收时间"></el-table-column>
                    <el-table-column property="yesNo" label="状态">
                        <template slot-scope="scope">
                            <span v-if="scope.row.yesNo=='0'">未开始</span>
                            <span v-else-if="scope.row.yesNo=='1'">已接收</span>
                            <span v-else-if="scope.row.yesNo=='2'">未接收</span>
                        </template>
                    </el-table-column>
                    <el-table-column property="why" label="备注"></el-table-column>
                 </el-table>
                 </div>
                 <!-- <el-pagination
                 @size-change="handleSizeChange1"
                 @current-change="handleCurrentChange1"
                 :current-page="currentPage1"
                 :page-sizes="[13, 26, 39, 52]"
                 :page-size="pageSize1"
                 layout="total, sizes, prev, pager, next, jumper"
                 :total="totalItems1"
               ></el-pagination> -->
          </el-dialog>
       <!-- 添加弹出框 -->
             <el-dialog
                    :title="diaTitle"
                    :visible.sync="addFormVisible"
                    width="500px"
                    center
                    :append-to-body="true"
                    :lock-scroll="false"
                    class="add-form"
                >
                    <el-form :model="addForm" ref="addForm" :rules="rules" label-width="100px" :label-position="labelPosition">
                        <el-form-item label="选择合同:" prop="entProjectId">
                           <el-select v-model="addForm.contractInitId" placeholder="请选择" class="tqmInfo-val">
                             <el-option
                               v-for="item in contractList"
                               :key="item.contractInitId"
                               :label="item.contractName"
                               :value="item.contractInitId">
                             </el-option>
                           </el-select>
                        </el-form-item>
                         <el-form-item label="接收人:">
                         <el-select v-model="addForm.receiveBy" placeholder="请选择" class="tqmInfo-val">
                             <el-option
                               v-for="item in projects1"
                               :key="item.userId"
                               :label="item.name"
                               :value="item.userId">
                             </el-option>
                           </el-select>
                        </el-form-item>
                       
                        <el-form-item label="移交附件:">
                             <el-upload
                                          class="upload-demo len100"
                                            :action="uploadUrl"
                                            :headers="uploadHead"
                                            :data="{type:232}"   
                                            :on-change="handleChange"
                                            :on-success="handleSuccess"
                                            :on-remove="handleDel"
                                            :file-list="addForm.file">
                                        <el-button size="small" type="primary">点击上传</el-button>
                                    </el-upload>
                        </el-form-item>
                        <el-form-item label="备注:">
                            <el-input type="textarea" :rows="2" v-model="addForm.note" autocomplete="off"></el-input>
                        </el-form-item>
                        
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="addFormVisible = false">取 消</el-button>
                        <el-button type="primary" @click="sumbitAddRow('addForm')">确 定</el-button>
                    </div>
                </el-dialog>


    </div>
</template>
<script>
import util from '../../untils/util'
import myHttp from '../../untils/port'
import base from '../../untils/base'
export default {
    data(){
        return{
            list:[{label:'我移交的合同列表',value:'1',name:'frist'},{label:'我接收的合同列表',value:'2',name:'second'}],
            count:0,
            count1:0,
            count2:0,
            search:{
                contractName:'',
                entProjectId:'',
                serialNum:'',//合同编号
                unitKind:'', //类型筛选
                principal:'',//负责人
                createBy:'',//  移交人
                receiveBy:'',//接收人
                type:1,
            },
            listData:[],
            gridData:[],
            currentPage: 1,
            pageSize: 10,
            totalItems: 0,
            diaTitle:"",
            labelPosition: 'right',
            dataText:"数据加载中...",
            projects:[],
            addFormVisible:false,
            addForm: {
                contractInitId:'',
                receiveBy:'',
                createBy:'',
                file:"",
                note:""
            },
             uploadUrl:myHttp.uploadFile, //上传地址
            uploadHead:{
                accessToken: util.session.get('token')
            },
            unitKinds:[{label:'项目采购类',value:'1'},{label:'管理服务类',value:'2'}],

            status:[{
             label:'全部',value:'1',
            },{
             label:'已接收',value:'2',
            },
            {
             label:'未接收',value:'3',
            },
            ], 
            dialogTableVisible:false      ,
            activeName: 'frist',
            rules:{
                // name: [{ required: true, message: '请输入合同名称', trigger: 'blur' } ],
                // serialNum:[{ required: true, message: '请输入合同编号', trigger: 'blur' } ],
                // unitKind:[{ required: true, message: '请选择单位种类', trigger: 'blur' } ],
            },
            contractList:[],
            projects1:[]
            
        }
    },
    mounted() {
        this.groupId = this.$store.state.groupId;
        if(''==this.groupId){
            this.$store.commit('setGroupId');
            this.groupId = this.$store.state.groupId;
        }
        this.addForm.entId=this.groupId

        this.getData()
    },
    methods:{
        doFilter(){
           
            this.getData()
        },
        handleSizeChange(val) {
            this.pageSize = val
            this.currentChangePage()
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.currentChangePage();
        },
        // 监控当前页码
        currentChangePage(list) {
            this.getData();
        },
        //点击过滤
        showProjectFun(index){
            this.search.unit = index
            this.getData()
        },
                 //监听上传文件
        handleChange(file){
            // this.fileList = fileList.slice(-3);
            console.log(file)
        },
        //上传文件成功
        handleSuccess(res, file,opt,other){
         var that=this
            if(res.code=='200'){
               // console.log(res.data.saveUrls)
              that.addForm.file = res.data.saveUrls
            }else{
                this.$message.error(res.msg);
            }
        },
        //监听文件删除
        handleDel(file,fileList){
          
        },
        //获取数据
        getData(){
            var that = this
            // this.search.contractName = this.contractName
            this.search.groupId = this.groupId
            this.search.pageNum = this.currentPage
            this.search.pageSize = this.pageSize
            this.search.userId = util.session.get('user').id
            // this.search.createBy = this.groupId
            myHttp.selectContractHandRecordList(this.search).then(function(resp){
                if(resp.data.code=='200'){
                    var list = resp.data.data.PageInfo.list;
                    for(var i=0;i<list.length;i++){
                        list[i].index = list[i].index = ((that.currentPage - 1) * that.pageSize)+(i+1);
                                                           
                    }
                    that.listData = list;
                    console.log(that.listData)
                    that.totalItems = resp.data.data.PageInfo.total
                    if(that.listData.length==0){
                        that.dataText = "暂无数据"
                    }
                }
            })
        },
        add(){
             this.addForm= {
                contractInitId:'',
                receiveBy:'',
                createBy:'',
                file:"",
                note:""
            },
         this.addFormVisible=true
         this.getContractList()
         this.getPerson()
        },
       // 查询合同列表
          getContractList(index){
          var that =this
           myHttp.selectContractByUserId({
                   entId:this.groupId,
                  principalId:util.session.get('user').id 
              })
                  .then(function(resp) {
                    if (resp.data.code == '200') {
                        console.log(resp.data)
                        var list = resp.data.data.contractPageInfo||[]
                        that.contractList =list
                        
                      console.log(that.projects)
                    }
                  })
         },
              /**获取负责人 */
        getPerson(){
           var that =this
           myHttp.selectEntPersonList({
                   entId:this.groupId 
              })
                  .then(function(resp) {
                    if (resp.data.code == '200') {
                       var list = resp.data.data.entPersonList||[]
                      that.projects1 =list
                    }
                  })
        },
               // 新增的数据
        sumbitAddRow(formName) {
            var that = this;
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    // if(that.addForm.id==''){
                       that.addForm.createBy =util.session.get('user').id
                        myHttp.handOverContract(that.addForm).then(function(resp){
                            if(resp.data.code=="200"){
                                that.$message.success("添加成功");
                                that.addFormVisible = false;
                                that.currentPage = 1;
                                that.getData();
                            }else{
                                that.$message.error(resp.data.msg);
                            }
                        },function(){});
                    // }else{
                    //   that.addForm.updateBy =util.session.get('user').id
                    //     myHttp.updateInfoContract(that.addForm).then(function(resp){
                    //         if(resp.data.code=="200"){
                    //             that.$message.success("修改成功");
                    //             that.addFormVisible = false;
                    //             that.currentPage = 1;
                    //             that.getData();
                    //         }else{
                    //             that.$message.error(resp.data.msg);
                    //         }
                    //     },function(){});
                    // }
                }
            });
        },
        //导出
        // exportOut(){
        //     var token = this.$store.state.token;
        //     window.open(myHttp.getExportInspectsByGroupId+'?groupId='+this.groupId+'&unit='+this.search.unit+'&date='+this.search.date+'&accessToken='+token)
        // },
        //查看
        handleEdit(index,row){
            console.log(row)
            this.dialogTableVisible=true
            this.addForm = row
            console.log(this.addForm)
            var that = this
            myHttp.selectContractHandRecordBycontractInitId({
                contractInitId:row.contractInitId
            }).then(function(resp){
                console.log(resp)
                if(resp.data.code=='200'){
                    var list = resp.data.data.List||[]
                    that.gridData = list
                }
            })
        },
        handleClick(targetName, action){
          //切换tab
          var type = parseInt(targetName.index) +1
            console.log(targetName.index);
            this.search.type = type
           this.getData()
        },
    }
}
</script>
<style scoped>
    .contain{
        width: 100%;
        height: 100%;
        position: relative;
    }
    .header-box{
        padding: 15px 20px;
        height: 70px;
        width: 100%;
        box-shadow: 1px 2px 3px 2px #ddd;
        background: #fff;
        box-sizing: border-box;
        position: relative;
        text-align: left;
        display: flex;
        align-items: center;
        justify-content: space-between;
        /* font-size: 18px; */
        /* color: #2058D9; */
    }
    .box{
        /* margin-top: 15px; */
        width: 100%;
        height: calc( 100% - 85px );
        background: #fff;
    }
    .box-content{
        width: 100%;
        height: calc( 100% - 55px );
        background: #fff;
    }
    .build-bar {
        display: flex;
        flex-direction: row;
        align-items: center;
         /* justify-content: space-between; */
        height: 80px;
        background: #fff;
        border-bottom: 3px solid #17b2fe;
        padding: 0 20px;
    }
 .el-form-item__label{
     color: inherit;
 }
 .el-tabs .el-tabs--top{
  height: 100%;
  background: #fff !important;
 }
  .desPro>>> .el-tabs__content {
    height: calc(100% - 60px) !important
   } 
   
   .el-tab-pane{
    height: 92%;
   }
</style>
<style>
    .build-bar span{
        margin-left: 0;
    }
    .el-table td, .el-table th{
        text-align: center;
    }
    .caozuo{
        display: flex;
        justify-content: flex-end;
    }
    /* .el-dialog{
        width: 500px;
    } */
</style>